import React from "react";
import "../styles/footer.css";
import instaImg from "../assets/images/insta.svg";
import fbImg from "../assets/images/fb.svg";
import twitterImg from "../assets/images/twitter.svg";
import linkedin from "../assets/images/linkedin.svg";
const footerDeco = "https://content.swageazy.com/website/footer_img.webp";

const Footer = ({ footerText, footerColor, customerId }) => {
  const defaultFooterText =
    "Enjoy your swag pack, and please know that you are valued and appreciated.";
  const defaultColor = "#1E1665";
  const resolvedFooterColor = footerColor || defaultColor;
  const showCopyright = customerId !== 383;

  return (
    <div className="footer-div p-0">
      <div className="text-white text-center">
        {footerText !== " " && (
          <div className="sub-footer">
            <img
              className="sub-footer-deco sub-footer-deco-left"
              src={footerDeco}
              alt=""
              aria-hidden="true"
            />
            <p className="p-0 m-0">{footerText || defaultFooterText}</p>
            <img
              className="sub-footer-deco sub-footer-deco-right"
              src={footerDeco}
              alt=""
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      <div
        className="footer-link"
        style={{ background: resolvedFooterColor }}
      >
        {/* <div className="d-flex justify-content-center gap-4 align-items-center">
          <a href="https://www.instagram.com/swageazyhq/" target="_blank">
            <img
              className="footer-img"
              src={instaImg}
              style={{ cursor: "pointer" }}
            />
          </a>
          <a href="https://www.facebook.com/swageazyhq" target="_blank">
            <img
              className="footer-img"
              src={fbImg}
              style={{ cursor: "pointer" }}
            />
          </a>
          <a href="https://www.linkedin.com/company/swageazy/" target="_blank">
            <img
              className="footer-img"
              src={linkedin}
              style={{ cursor: "pointer" }}
            />
          </a>
          <a href="https://twitter.com/swageazyhq" target="_blank">
            <img
              className="footer-img"
              src={twitterImg}
              style={{ cursor: "pointer" }}
            />
          </a>
        </div> */}
        {/* <div
          className="horizontal-line mt-4 mb-4"
          style={{ border: "1px solid #2C246C", opacity: "1" }}
        /> */}
        {/* <a
          href="https://swageazy.com/"
          target={"_blank"}
          style={{ textDecoration: "none", color: "white" }}
        >
          <div
            className="heading-5   text-center"
            style={{ background: "#1E1665" }}
          >
            Copyright © 2025, Powered by Swageazy, All rights reserved.
          </div>
        </a> */}

        {showCopyright ? (
          <>
            <a
              href="https://swageazy.com/"
              target={"_blank"}
              style={{ textDecoration: "none", color: "white" }}
            >
              <div
                className="heading-5   text-center"
                style={{ background: resolvedFooterColor }}
              >
                Copyright © 2026, Powered by Swageazy, All rights reserved.
              </div>
            </a>
          </>
        ) : (
          <div
          // className="horizontal-line mt-4"
          // style={{ border: "1px solid #2C246C", opacity: "1" }}
          />
        )}
      </div>
    </div>
  );
};

export default Footer;
